import { FileGenerationStatus, SearchSource } from 'features/chat/types/chat';

export enum SSEResponseTypes {
  CODE_EXECUTION_STARTED = 'CODE_EXECUTION_STARTED',
  CODE_EXECUTION_STEP = 'CODE_EXECUTION_STEP',
  CODE_EXECUTION_ARTIFACT = 'CODE_EXECUTION_ARTIFACT',
  LLM_ANSWER = 'LLM_ANSWER',
  SERVER_ERROR = 'SERVER_ERROR',
  TOKEN_ANALYTICS = 'TOKEN_ANALYTICS',
  CONVERSATION_TITLE = 'CONVERSATION_TITLE',
  END_OF_STREAM = 'END_OF_STREAM',
  LLM_THINKING = 'LLM_THINKING',
  FILE_GENERATION_ON_PROGRESS = 'FILE_GENERATION_ON_PROGRESS',
  IMAGE_GENERATION_STARTED = 'IMAGE_GENERATION_STARTED',
  IMAGE_GENERATION_SUCCESS = 'IMAGE_GENERATION_SUCCESS',
  IMAGE_GENERATION_FAILED = 'IMAGE_GENERATION_FAILED',
  CONTEXT_WINDOW_EXCEEDED = 'CONTEXT_WINDOW_EXCEEDED',
  IMAGE_GENERATION_LIMIT_EXCEEDED = 'IMAGE_GENERATION_LIMIT_EXCEEDED',
  FILE_GENERATION_STARTED = "FILE_GENERATION_STARTED",
  FILE_GENERATION_SUCCESS = "FILE_GENERATION_SUCCESS",
  FILE_GENERATION_FAILED = "FILE_GENERATION_FAILED",
  RESPONSE_SOURCES = "SOURCES",
  SEARCH_SOURCES = "SEARCH_SOURCES",
  SEARCH_RESPONSE = "SEARCH_RESPONSE",
  ASSISTANT_REQUEST_PROCESSING_STARTED = "ASSISTANT_REQUEST_PROCESSING_STARTED",
  ASSISTANT_REQUEST_QUEUED = "ASSISTANT_REQUEST_QUEUED",
  RESPONSE_TIME_ANALYTICS = "RESPONSE_TIME_ANALYTICS",
  MODEL_SELECTED = "MODEL_SELECTED",
  STREAM_CANCELLED = "STREAM_CANCELLED"
}

export interface GeneratedFile {
  file_id: string;
  file_name: string;
  file_size?: number | null;
  file_type: string;
  error?: string;
  status: FileGenerationStatus;
  message?: string;
}

export interface TokenAnalytics {
  completion_tokens: number;
  prompt_tokens: number;
  total_tokens: number;
}

export interface SourceFile {
  file_id: string;
  file_name: string;
  chunks: any[];
}

export interface ResponseTimeAnalytics {
  userId: string;
  orgId: string;
  tenantId: string;
  conversationId: string;
  messageId: string;
  pipelineStartedAt: string;
  pipelineEndedAt: string;
  hasUploadedFiles: boolean;
  allDetectedIntents: string[];
  timeToFirstTokenMs: number;
  totalPipelineDurationMs: number;
  error: string | null;
}

export interface ModelSelected {
  selected_model: string;
  detected_capability: string;
}

export interface SSEResponse {
  data: string | TokenAnalytics | GeneratedFile | SourceFile[] | SearchSource[] | ResponseTimeAnalytics | ModelSelected | AssistantPositionRemainingType;
  type: SSEResponseTypes;
  conversation_id: string;
  file_names?: string[];
  assistant_message_id?: string;
  message_sender_id?: string;
  parent_ids?: string[];
}

export interface AssistantPositionRemainingType {
  message: string;
  position: number;
  remaining: number;
}